"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.useNavigation = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Logo = _interopRequireDefault(require("../Logo"));

var _Avatar = _interopRequireDefault(require("../Avatar"));

require("../assets/css/font-face.css");

require("./HeaderDesktop.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var HeaderDesktop = function HeaderDesktop(_ref) {
  var user = _ref.user,
      links = _ref.links,
      collections = _ref.collections,
      project = _ref.project,
      onClick = _ref.onClick,
      className = _ref.className,
      activeItem = _ref.activeItem,
      props = _objectWithoutProperties(_ref, ["user", "links", "collections", "project", "onClick", "className", "activeItem"]);

  var wrapperClass = 'header-desktop';
  if (className) wrapperClass += " ".concat(className);
  return _react.default.createElement("div", _extends({}, props, {
    className: wrapperClass
  }), _react.default.createElement("div", {
    className: "header-desktop__row"
  }, _react.default.createElement("div", {
    className: "header-desktop__content"
  }, _react.default.createElement("div", {
    className: "header-desktop__left-content"
  }, _react.default.createElement(_Logo.default, null), _react.default.createElement("p", {
    className: "header-desktop__project-name",
    style: {
      color: project.color
    }
  }, project.name)), _react.default.createElement("div", {
    className: "header-desktop__right-content"
  }, _react.default.createElement(User, {
    user: user,
    links: links,
    onClick: onClick
  })))), useNavigation(collections, activeItem, onClick));
};

var User = function User(_ref2) {
  var user = _ref2.user,
      links = _ref2.links,
      _onClick = _ref2.onClick;
  return _react.default.createElement("div", {
    className: "header-desktop__user"
  }, _react.default.createElement(_Avatar.default, {
    size: "small",
    src: user.avatar,
    rounded: true
  }), _react.default.createElement("div", {
    className: "header-desktop__user-dropdown"
  }, _react.default.createElement("div", {
    className: "header-desktop__user-dropdown-content"
  }, _react.default.createElement("div", {
    className: "header-desktop__user-info"
  }, _react.default.createElement("span", null, user.name), _react.default.createElement("small", null, user.email)), _react.default.createElement("ul", {
    className: "header-desktop__user-list"
  }, Object.keys(links).map(function (key) {
    return _react.default.createElement("li", {
      className: "header-desktop__user-item",
      key: links[key].title
    }, _react.default.createElement("span", {
      onClick: function onClick() {
        return _onClick(links[key].url);
      },
      className: "header-desktop__user-link"
    }, links[key].title));
  })))));
};

var useNavigation = function useNavigation(collections, activeItem, callback) {
  var _useState = (0, _react.useState)(activeItem),
      _useState2 = _slicedToArray(_useState, 2),
      activeNavItem = _useState2[0],
      setActiveNavItem = _useState2[1];

  (0, _react.useEffect)(function () {
    setActiveNavItem(activeItem);
  }, [activeItem]);

  var handleClick = function handleClick(url) {
    setActiveNavItem(url);
    callback(url);
  };

  var MenuItem = function MenuItem(_ref3) {
    var item = _ref3.item;
    var itemClass = 'header-desktop__item';

    if (activeNavItem === item.url) {
      itemClass += ' header-desktop__item--active';
    }

    return _react.default.createElement("li", {
      className: itemClass
    }, _react.default.createElement("span", {
      onClick: function onClick(e) {
        return handleClick(item.url, e);
      },
      className: "header-desktop__link"
    }, item.title));
  };

  if (collections.length === 0) return null;
  return _react.default.createElement("div", {
    className: "header-desktop__row header-desktop__row--second"
  }, _react.default.createElement("div", {
    className: "header-desktop__content"
  }, _react.default.createElement("nav", {
    className: "header-desktop__nav"
  }, _react.default.createElement("ul", {
    className: "header-desktop__list"
  }, collections.map(function (item) {
    return _react.default.createElement(MenuItem, {
      item: item,
      key: item.title
    });
  })))));
};

exports.useNavigation = useNavigation;
HeaderDesktop.defaultProps = {
  collections: [],
  user: {
    name: '',
    email: '',
    avatar: ''
  },
  links: {},
  onClick: function onClick() {},
  activeItem: null,
  project: {
    color: '',
    name: ''
  }
};
HeaderDesktop.propTypes = {
  /** The categories to navigation menu */
  collections: _propTypes.default.array,

  /** The user info name, email and avatar */
  user: _propTypes.default.object,

  /** The dropdown links when hover the user avatar */
  links: _propTypes.default.object,

  /** Highlighted item in menu */
  activeItem: _propTypes.default.string,

  /** The name and color aside of yapay logo */
  project: _propTypes.default.shape({
    color: _propTypes.default.string,
    name: _propTypes.default.string
  })
};
var _default = HeaderDesktop;
exports.default = _default;